<template>
    <!-- content -->
    <div id="closing_wrapper" class="fade_out" :class="isArabiaLang"><!-- 아랍어일때 lang-ar 추가 -->
        <div id="closing_header">
            <div class="header_wrap in_sec">
                <p :dir="langDir" v-html="$t('sdp.close.message.01')"></p>
                <p :dir="langDir" v-html="$t('sdp.close.message.02')"></p>
            </div>
        </div>

        <div id="closing_content">
            <div class="fade_out_message in_sec">
                <div class="message_point">
                    <table border="1" class="table_list" summary="">
                        <caption></caption>
                        <colgroup>
                            <col width="50%">
                            <col>
                        </colgroup>

                        <thead>
                        <tr><th scope="col" :dir="langDir" v-html="$t('sdp.close.message.03')"></th>
                            <th scope="col" :dir="langDir" v-html="$t('sdp.close.message.04')"></th>
                        </tr></thead>

                        <tbody>
                        <tr><td class="date" :dir="langDir" v-html="$t('sdp.close.message.05')"></td> <!-- 2016.11.30 Mod 홍병기K -->
                            <td  :dir="langDir" v-html="$t('sdp.close.message.06')"></td>
                        </tr></tbody>
                    </table>

                    <ul>
                        <li :dir="langDir" v-html="$t('sdp.close.message.07')"></li>
                        <li :dir="langDir" v-html="$t('sdp.close.message.08')"></li>
                        <li :dir="langDir" v-html="$t('sdp.close.message.09')"></li>
                    </ul>
                </div>
            </div>
            <div class="fade_out_comment">
                <div class="fade_out_comment_wrap in_sec">
                    <p :dir="langDir" v-html="$t('sdp.close.message.10')"></p>

                    <p :dir="langDir" class="point" v-html="$t('sdp.close.message.11') + '<br>' + $t('sdp.close.message.12')"></p>

                    <p :dir="langDir" v-html="$t('sdp.close.message.13') + '<br>' + $t('sdp.close.message.14')"></p>
                    <p :dir="langDir" v-html="$t('sdp.close.message.15')"></p>
                </div>
            </div>
        </div>
        <div class="copyright" style="direction:ltr;">COPYRIGHT ⓒ LG ELECTRONICS. ALL RIGHTS RESERVED.</div>
    </div>
    <!-- //content -->
</template>

<script>
export default {
  name: "ClosingServiceGuide",
  data() {
    return {        
    }
  },
  mounted() {
      console.log('ClosingServiceGuide.mounted.');
  },
  watch: {
    $route: "fetchData"
  },
  computed: {
      isArabiaLang: function() {
          if(_domainLangCode == "ara" || _domainLangCode == "per") {
              return "lang-ar";
          } else {
              return "";
          }
      },
      langDir: function() {
          if(_domainLangCode == "ara" || _domainLangCode == "per") {
              return "rtl";
          } else {
              return "ltr";
          }
      }
  },
  methods: {
    track () {
		console.log('@@@@ track:', this.$router.currentRoute.path);
		this.$ga.page(this.$router.currentRoute.path)
	},
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
